<template src="./Loading.html">
</template>

<script>

export default {
    name: 'loading-modal',
    props: {
      isLoading: false,
      message: {
        type: String,
        default: 'Loading...'
      },
      progress: {
        type: Number,
        default: 0
      }
    }
}
</script>
